<template>
    <div class="main">
        <c-panel title="CÓPIA DE ANO LETIVO" titleIcon="fas fa-copy">

            <el-steps :active="passo" finish-status="success" align-center class="u-mb-25">
                <el-step title="Origem e destino"></el-step>
                <el-step title="O que copiar"></el-step>
                <el-step title="Executar"></el-step>
            </el-steps>

            <div v-if="passo === 0">
                <el-form label-position="top" @submit.native.prevent>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8">
                            <el-form-item label="Período de origem">
                                <el-select v-model="origem" style="width: 100%;">
                                    <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8">
                            <el-form-item label="Período de destino">
                                <el-select v-model="destino" style="width: 100%;">
                                    <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8">
                            <el-form-item label="Escola (opcional — vazio = toda a rede)">
                                <el-select v-model="instituicaoId" filterable clearable placeholder="Toda a rede" style="width: 100%;">
                                    <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="u-text-right u-mt-20">
                    <el-button type="primary" :disabled="!origem || !destino" @click="rodarPrevia">GERAR PRÉVIA</el-button>
                </div>
            </div>

            <div v-if="passo === 1 && previa">
                <el-alert type="info" :closable="false" class="u-mb-15" :title="previa.aviso"></el-alert>

                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 50px;" class="u-text-center">Copiar</th>
                                <th>Item</th>
                                <th class="u-text-center" style="width: 130px;">Na origem</th>
                                <th class="u-text-center" style="width: 130px;">Já no destino</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(v, k) in previa.itens" :key="k">
                                <td class="u-text-center"><el-checkbox v-model="opcoes[k]" :disabled="v.origem === 0"></el-checkbox></td>
                                <td>{{ rotuloItem(k) }}</td>
                                <td class="u-text-center">{{ v.origem }}</td>
                                <td class="u-text-center">{{ v.destino }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="u-text-right u-mt-20">
                    <el-button @click="passo = 0">VOLTAR</el-button>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" :disabled="!algumMarcado" @click="executar">EXECUTAR CÓPIA</el-button>
                </div>
            </div>

            <div v-if="passo === 2 && resultado">
                <el-alert type="success" :closable="false" class="u-mb-15" :title="resultado.mensagem"></el-alert>
                <div class="container-table">
                    <table class="table table-striped">
                        <thead><tr><th>Item</th><th class="u-text-center">Criados</th><th class="u-text-center">Já existiam</th><th>Observação</th></tr></thead>
                        <tbody>
                            <tr v-for="(v, k) in resultado.resumo" :key="k">
                                <td>{{ rotuloItem(k) }}</td>
                                <td class="u-text-center">{{ v.criados }}</td>
                                <td class="u-text-center">{{ v.ignorados }}</td>
                                <td>{{ v.aviso || '—' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="u-text-right u-mt-20">
                    <el-button @click="reiniciar">NOVA CÓPIA</el-button>
                </div>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO E — item 54: cópia de ano letivo, com prévia read-only antes de gravar. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        passo: 0,
        origem: null, destino: null, instituicaoId: null,
        instituicoes: [],
        previa: null, resultado: null, opcoes: {}
    }),
    computed: {
        algumMarcado () { return Object.keys(this.opcoes).some(k => this.opcoes[k]) },
        /** Esconder o botão não é segurança: o backend recusa de qualquer forma. */
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})
    },
    methods: {
        rotuloItem (k) {
            return { calendario: 'Calendário escolar (marcações diárias)', eventos: 'Eventos do calendário',
                periodos_avaliativos: 'Períodos avaliativos das matrizes', quadro_vagas: 'Quadro de vagas',
                configuracao_horario: 'Configurações de horário', documentos_matricula: 'Documentos obrigatórios da matrícula',
                turmas: 'Turmas (sem matrículas)' }[k] || k
        },
        rodarPrevia () {
            window.eventBus.$emit('loading', true)
            const base = `${this.$store.state.config.baseUrlApi}/api/copia-ano-letivo/previa/${this.origem}/${this.destino}`
            this.$axios.get(base + (this.instituicaoId ? '/' + this.instituicaoId : ''),
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.previa = r.data
                this.opcoes = {}
                Object.keys(r.data.itens).forEach(k => { this.$set(this.opcoes, k, r.data.itens[k].origem > 0) })
                this.passo = 1
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        executar () {
            this.$confirm('Executar a cópia dos itens marcados?', 'Confirmação', {
                confirmButtonText: 'Executar', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/copia-ano-letivo/executar`,
                    { periodo_origem_id: this.origem, periodo_destino_id: this.destino,
                      instituicao_id: this.instituicaoId, opcoes: this.opcoes },
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    this.resultado = r.data
                    this.passo = 2
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            }).catch(() => {})
        },
        reiniciar () { this.passo = 0; this.previa = null; this.resultado = null; this.opcoes = {} },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
